export default "__VITE_ASSET__C1RrYgKZ__"